<template lang="pug">
.page 
    a-modal(v-model="addFee.visible" title="添加手续费" @ok="handleSumitAddFee")
        a-form
            a-form-item(label="Date")
                div {{addFee.date}}
            a-form-item(label="Fee")
                a-input-number(v-model="addFee.fee" style="width: 100%")


    .ctl-bar 
        a-button(type="primary" @click="getData") Refresh
        a-button(type="primary" 
            style="margin-left:10px"
            @click="exportDataCSV") Export CSV

    a-table(:columns="columns" 
        row-key="_id"
        size="small"
        :loading="loading"
        :pagination="{ pageSize: 20 }"
        :dataSource="items")
        template(slot="add_fee" slot-scope="record")
            a-button(type="primary" 
                @click="handleAdd(record)" 
                size="small" 
                icon="plus") Add
</template>

<script> 
import _ from 'lodash';

export default {
    props: ['bookName', 'isAdmin'],
    data() {
        let columns = [
            {
                title: 'Date',
                dataIndex: 'date'
            },
            {
                title: 'Total Pnl',
                dataIndex: 'pnl'
            },
            {
                title: 'Total Daily Pnl',
                dataIndex: 'daily_pnl'
            },
            {
                title: 'Stock Daily Pnl',
                dataIndex: 'daily_stock_pnl',
            },
            {
                title: 'Option Daily Pnl',
                dataIndex: 'daily_option_pnl',
            },
            {
                title: 'Time Value',
                dataIndex: 'time_value',
            },
            {
                title: 'Intrinsic Value',
                dataIndex: 'instrinsic_value'
            },
            {
                title: 'Total Premium',
                dataIndex: 'total_premium'
            },
            {
               title: 'Fee',
                key: 'manual_fee',
                dataIndex: 'manual_fee',
            }
        ];

        if (this.isAdmin) {
            columns.push({
                title: 'Add Fee',
                key: 'add_fee',
                scopedSlots: {customRender: 'add_fee'}
            });
        }
        return {
            loading: false,
            columns,
            items: [],
            addFee: {
                visible: false,
                date: '',
                fee: 0,
                
            },
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        exportDataCSV() {
            let header = ['Date', 'Total Pnl', 'Total Daily Pnl', 'Stock Daily Pnl', 'Option Daily Pnl', 'Time Value', 'Intrinsic Value', 'Total Premium', 'Fee'];
            let csv = header.join(',') + '\n';
            _.forEach(this.items, item => {
                let row = [
                    item.date,
                    item.pnl,
                    item.daily_pnl,
                    item.daily_stock_pnl,
                    item.daily_option_pnl,
                    item.time_value,
                    item.instrinsic_value,
                    item.total_premium,
                    item.manual_fee,
                ];
                csv += row.join(',') + '\n';
            });
            let blob = new Blob([csv], {type: 'text/csv'});
            let url = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${this.bookName}_pnl.csv`;
            a.click();
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 100);
        },
        getData() {
            this.loading = true;
            let total_pnl = 0;

            this.$api.request('GET', `hkoption/${this.bookName}/history_pnl`)
            .then(res => {
                let data = [];
                _.forEach(res.data, item => {
                    let daily_pnl = item.daily_pnl - item.manual_fee;
                    total_pnl += daily_pnl;

                    data.push({
                        date: item.date,
                        manual_fee: item.manual_fee,
                        manual_other_fee: item.manual_other_fee,
                        daily_pnl: Math.round(daily_pnl * 1000)/1000,
                        daily_stock_pnl: Math.round(item.daily_stock_pnl * 1000)/1000,
                        daily_option_pnl: Math.round(item.daily_option_pnl * 1000)/1000,
                        pnl: Math.round(total_pnl*1000)/1000,
                        time_value: Math.round(item.time_value * 1000)/1000,
                        instrinsic_value: Math.round(item.instrinsic_value * 1000)/1000,
                        total_premium: Math.round(item.total_premium * 1000)/1000,
                    })
                });
                this.items = data;
                this.loading = false;
            });
        },
        handleAdd(record) {
            this.addFee = {
                visible: true,
                date: record.date,
                fee: record.manual_fee,
                
            };
        },
        handleSumitAddFee() {
            this.$api.request('POST', 'hkoption/manualOptionFee/'+this.bookName, {
                date: this.addFee.date,
                fee: this.addFee.fee,
                
            })
            .then(res => {
                this.addFee.visible = false;
                this.getData();
            })
        }
    }
}
</script>